import { render } from "./FormGroup.vue?vue&type=template&id=3f04ce4b&scoped=true"
import script from "./FormGroup.vue?vue&type=script&lang=js"
export * from "./FormGroup.vue?vue&type=script&lang=js"

import "./FormGroup.vue?vue&type=style&index=0&id=3f04ce4b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f04ce4b"]])

export default __exports__